module.exports = __webpack_public_path__ + "static/media/3-1.09fd2b95.png";